export const RAISIN_BANK_LOGO = 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt755c7d81254bfe8d/raisin-bank-logo.svg';
export const RAISIN_LOGO = 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg';
export const RAISIN_LIGHT_BLUE_SITE_LOGO = ' https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt6edc2e97ec97de8a/raisin_light_blue_site_logo.svg';
export const AUTH_TOKEN_KEY = 'auth_token';
export const DEFAULT_DISTRIBUTOR = 'Raisin';
export const EXTERNAL_DOMAINS_REGEX = /^(https?:\/\/|www\.)/;
//# sourceMappingURL=index.js.map